// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/index.scss
// module id = 5
// module chunks = 0